import { render } from "./GroupTable.vue?vue&type=template&id=74c18382&scoped=true"
import script from "./GroupTable.vue?vue&type=script&lang=js"
export * from "./GroupTable.vue?vue&type=script&lang=js"

import "./GroupTable.vue?vue&type=style&index=0&id=74c18382&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c18382"]])

export default __exports__